import React, { useRef, useState, useEffect } from "react"
import { Button, Input, Card } from '../components/primitives/';
import { useAuth } from "../contexts/AuthContext"
import { Link, useLocation } from "react-router-dom"
import Logo from '../assets/pplogo.png';
import { useTranslation } from '../hooks/useTranslation';
import useTimedError from "../hooks/useTimedError";

// https://temp-mail.org/en/

export default function ForgotPassword() {
  const t = useTranslation();
  const location = useLocation();
  
  const emailRef = useRef(location.state?.email || "")
  const { sendPasswordResetEmail } = useAuth()
  const [error, setError] = useTimedError();
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown > 0) {
        const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        return () => clearTimeout(timer);
    }
  }, [countdown]);

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    try {
      await sendPasswordResetEmail(emailRef.current.value)
      setMessage(t("Check your inbox for further instructions."))
      setCountdown(60)
    } catch {
      setError(t("Failed to reset password"))
    }
    setLoading(false)
  }

    return (
        <div className="auth-page">
            <div className="auth-outer-container">
                <div className="logo-group">
                    <a href="https://pageparrot.com" className="logo-group-inner">
                        <img className="logo-signin" src={Logo} alt="Page Parrot Logo" />
                        <h2 className="logo-heading w-900 text-center">{t('Page Parrot')}</h2>
                    </a>
                </div>
                <Card className="auth-container centered">
                    <h2 className="text-center mb-4">{t('Forgot Password')}</h2>
                    <div className="auth-info-text">
                        {t('Enter the email address you used to register.')}
                        <br/>
                        {t('You\'ll receive an email with instructions on how to reset your password.')}
                        <br/>
                        {message && <span className="success">{message}</span>}
                    </div>
                    <form onSubmit={handleSubmit}>
                        <Input ref={emailRef} labelText={t('Email')} id="email" required={true} type="email" />
                        <Button disabled={loading || countdown > 0} buttonType="submit" error={error} loading={loading}>
                            {error ? error : countdown > 0 ? `Wait ${countdown}s` : t('Submit')}
                        </Button>
                    </form>
                    <div className="w-500 fs-12 text-center">
                        {t('Remembered your password?')}
                    </div>
                    <div className="w-500 fs-12 text-center">
                        <Link to="/login" state={{ email: emailRef.current?.value }}>{t('Sign In Here')}</Link>
                    </div>
                    <div className="w-500 fs-12 text-center" style={{ marginTop: "10px" }}>
                        {t('Need an account?')} <Link to="/signup" state={{ email: emailRef.current?.value }}>{t('Sign Up')}</Link>
                    </div>
                </Card>
            </div>
        </div>
    )
}
